import * as api from '../../services/cmOrder'
import lodash from 'lodash'

export const FETCH_TICKETORDERS= 'FETCH_TICKETORDERS';
export const FETCH_VASORDERS= 'FETCH_VASORDERS';
export const FETCH_LUCKMONEYORDERS= 'FETCH_LUCKMONEYORDERS';
export const FETCH_REWARDORDERS= 'FETCH_REWARDORDERS';
export const FETCH_MARKETORDERS= 'FETCH_MARKETORDERS';
export const FETCH_ORDERS= 'FETCH_ORDERS';



// export const fetchIos = (id) => ({
//     type: FETCH_IOS,
//     payload: {
//         promise: api.findIos({id: id})
//     }
// });


export const fetchTicketOrders = (params, pagination, sort, extra) => {

    return {
        type: FETCH_TICKETORDERS,
        payload: {
            promise: api.findTicketOrders(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership','eventId'),
            sort: sort,
            extra: extra
        }
    };
};
export const fetchVasOrders = (params, pagination, sort, extra) => {

    return {
        type: FETCH_VASORDERS,
        payload: {
            promise: api.findVasOrders(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership'),
            sort: sort,
            extra: extra
        }
    };
};
export const fetchLuckMoneyOrders = (params, pagination, sort, extra) => {

    return {
        type: FETCH_LUCKMONEYORDERS,
        payload: {
            promise: api.findLuckMoneyOrders(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership'),
            sort: sort,
            extra: extra
        }
    };
};
export const fetchRewardOrders = (params, pagination, sort, extra) => {

    return {
        type: FETCH_REWARDORDERS,
        payload: {
            promise: api.findRewardOrders(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership'),
            sort: sort,
            extra: extra
        }
    };
};
export const fetchMarketOrders = (params, pagination, sort, extra) => {

    return {
        type: FETCH_MARKETORDERS,
        payload: {
            promise: api.findMarketdOrders(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership'),
            sort: sort,
            extra: extra
        }
    };
};
export const fetchOrders = (params, pagination, sort, extra) => {

    return {
        type: FETCH_ORDERS,
        payload: {
            promise: api.findOrders(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership'),
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/cmOrder.js